// M8 — Manager tour: Material Orders. 2 steps on /materialorders.
export default {
  key: 'M8',
  route: '/materialorders',
  steps: [
    {
      id: 'list',
      target: '[data-tour-id="materialorders.list"]',
      title: 'Material Orders',
      desc: 'Material Orders capture purchases of raw materials. Each row tracks supplier, quantity, and status.',
    },
    {
      id: 'supplier-flow',
      target: '[data-tour-id="materialorders.list"]',
      title: 'Supplier & delivery',
      desc: 'Open an order to link a supplier, track delivery, and attach files. Material orders are auto-created when scheduling identifies a material shortage.',
    },
  ],
}
